export default "__VITE_ASSET__df975573__"